import React, { useEffect, useMemo, useState } from "react";
import { Stack, TextField, InputAdornment, Box, Button } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export function IntervalMinutesField({ item, onSave }) {
    const initial = item.intervalMinutes ?? "";
    const [value, setValue] = useState(initial);

    useEffect(() => setValue(initial), [initial]);

    const handleChange = (e) => {
        const raw = e.target.value;
        if (raw === "") {
            return;
        }
        const n = Number(raw);
        if (!Number.isNaN(n)) {
            setValue(Math.max(1, Math.trunc(n)));
        }
    };

    const dirty = useMemo(() => {
        // сравнение: "" ~ null
        const normInit = initial === "" ? null : Number(initial);
        const normVal = value === "" ? null : Number(value);
        return normInit !== normVal;
    }, [initial, value]);

    const canSave =
        value === "" || (Number.isFinite(Number(value)) && Number(value) >= 1);

    return (
        <Box>
            <div style={{ height: "10px" }} />
            <Stack direction="row" spacing={1} alignItems="center">
                <TextField
                    label="Интервал"
                    size="small"
                    type="number"
                    value={value}
                    onChange={handleChange}
                    placeholder="нет"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <AccessTimeIcon fontSize="small" />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">мин.</InputAdornment>
                        ),
                    }}
                    sx={{ width: 200 }}
                />

                {dirty && (
                    <>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => onSave(value === "" ? null : Number(value))}
                            disabled={!canSave}
                            sx={{ textTransform: "none", fontWeight: 600 }}
                        >
                            Сохранить
                        </Button>
                        <Button
                            variant="text"
                            size="small"
                            onClick={() => setValue(initial)}
                            sx={{ textTransform: "none" }}
                        >
                            Отмена
                        </Button>
                    </>
                )}
            </Stack>
        </Box>
    );
}
